module.exports = __webpack_public_path__ + "static/media/mainvisual_wide.2dae3f85.jpg";